import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { EnvironmentHelper, readEnv } from "@repo/helpers";
// Subpath import to avoid circular dependency: @repo/api ↔ @repo/logic
import { LocalStorageKeys } from "@repo/logic/constants";

// Read env vars from window.__WEB_ENV__ directly — readEnv() via @repo/helpers
// is unreliable in workspace packages under Vite dev mode.
// Falls back to GATSBY_ prefixed vars for web-old (Gatsby) compatibility.
const _env = (typeof window !== "undefined" && (window as any).__WEB_ENV__) || {};
const domain = _env["VITE_B2C_DOMAIN"] ?? readEnv("VITE_B2C_DOMAIN") ?? readEnv("GATSBY_B2C_DOMAIN") ?? "";
const tenantId = _env["VITE_B2C_TENANT_ID"] ?? readEnv("VITE_B2C_TENANT_ID") ?? readEnv("GATSBY_B2C_TENANT_ID") ?? "";
const signInPolicy = _env["VITE_B2C_SIGNUP_SIGNIN_POLICY"] ?? readEnv("VITE_B2C_SIGNUP_SIGNIN_POLICY") ?? readEnv("GATSBY_B2C_SIGNUP_SIGNIN_POLICY") ?? "";
const defaultAuthority = domain && tenantId && signInPolicy
    ? `https://${domain}/${tenantId}/${signInPolicy}`
    : "";

const authority = EnvironmentHelper.isBrowser()
    ? (localStorage.getItem(LocalStorageKeys.LAST_USED_AUTHORITY) || defaultAuthority)
    : "";

const msalConfig: Configuration = {
    auth: {
        clientId: _env["VITE_B2C_CLIENT_ID"] ?? readEnv("VITE_B2C_CLIENT_ID") ?? readEnv("GATSBY_B2C_CLIENT_ID") ?? "B2C_CLIENT_ID not set!",
        knownAuthorities: [domain], // You must identify your tenant's domain as a known authority.
        redirectUri: "/prihlaseni",
        postLogoutRedirectUri: "/prihlaseni",
        navigateToLoginRequestUrl: false,
        authority,
    },
    cache: {
        cacheLocation: "localStorage",
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Auto-initialize MSAL instance immediately if in browser
// This must complete before any API calls
let initPromise: Promise<void> | null = null;

if (EnvironmentHelper.isBrowser()) {
    initPromise = msalInstance.initialize().catch((error) => {
        console.error("MSAL initialization failed in @repo/api:", error);
        throw error;
    });
}

// Export a promise that resolves when MSAL is ready
export const msalReady = initPromise || Promise.resolve();
